<template>
    <el-dialog :title="title" :visible="showDialog" width="90%" top="3vh" @close="close">
        <div v-loading="loading">
            <el-tabs v-model="activeTab">
                <el-tab-pane label="General" name="general">

                    <h4>Datos de la carta</h4>

                    <div class="row">
                        <div class="col-md-4">
                            <label>Nombre de la carta</label>

                            <el-input v-model="form.name" placeholder="Ejemplo: Carta principal">
                            </el-input>
                        </div>

                        <div class="col-md-4">
                            <label>Establecimiento</label>

                            <el-select v-model="form.establishment_id" class="w-100" filterable>
                                <el-option v-for="row in establishments" :key="row.id" :label="row.description"
                                    :value="row.id">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="col-md-4">
                            <label>Diseño</label>

                            <el-select v-model="form.template" class="w-100">
                                <el-option v-for="row in templates" :key="row.id" :label="row.description"
                                    :value="row.id">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="col-md-12 mt-3">
                            <label>Descripción</label>

                            <el-input v-model="form.description" type="textarea" :rows="3">
                            </el-input>
                        </div>
                    </div>

                    <h4>Publicación</h4>

                    <div class="row">
                        <div class="col-md-3">
                            <el-switch v-model="form.published" active-text="Publicada" inactive-text="Borrador">
                            </el-switch>
                        </div>

                        <div class="col-md-3">
                            <el-switch v-model="form.is_default" active-text="Predeterminada">
                            </el-switch>
                        </div>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="Apariencia" name="appearance">
                    <h4>Colores</h4>
                    <div class="row">
                        <div class="col-md-4">
                            <label>Color principal</label>

                            <el-input v-model="form.primary_color" placeholder="#8F1D14" maxlength="9" @blur="
                                normalizeColor(
                                    'primary_color',
                                    '#8F1D14'
                                )
                                ">
                                <el-color-picker slot="prepend" v-model="form.primary_color" size="mini"
                                    color-format="hex" popper-class="instant-color-picker"
                                    @active-change="changeColor('primary_color', $event)"
                                    @change="changeColor('primary_color', $event)">
                                </el-color-picker>
                            </el-input>

                            <small class="text-muted">
                                Se utiliza en cabeceras y elementos principales.
                            </small>
                        </div>

                        <div class="col-md-4">
                            <label>Color secundario</label>

                            <el-input v-model="form.secondary_color" placeholder="#F4B942" maxlength="9" @blur="
                                normalizeColor(
                                    'secondary_color',
                                    '#F4B942'
                                )
                                ">
                                <el-color-picker slot="prepend" v-model="form.secondary_color" size="mini"
                                    color-format="hex" popper-class="instant-color-picker"
                                    @active-change="changeColor('secondary_color', $event)"
                                    @change="changeColor('secondary_color', $event)">
                                </el-color-picker>
                            </el-input>

                            <small class="text-muted">
                                Se utiliza en precios, detalles y destacados.
                            </small>
                        </div>

                        <div class="col-md-4">
                            <label>Vista del diseño</label>

                            <button type="button" class="btn btn-outline-info btn-block" :disabled="!form.id"
                                @click.prevent="openPreview">
                                <i class="fa fa-eye"></i>
                                Ver vista previa
                            </button>

                            <small v-if="!form.id" class="text-muted">
                                Guarde la carta para habilitar esta opción.
                            </small>
                        </div>
                    </div>

                    <!-- PORTADA PARA CARTA -->

                    <!-- <div class="row">
                        <div class="col-md-6">
                            <label>Portada de la carta</label>

                            <el-upload action="" accept=".jpg,.jpeg,.png,.webp" :show-file-list="false"
                                :http-request="uploadCover">
                                <button type="button" class="btn btn-info btn-sm">
                                    <i class="fa fa-upload"></i>
                                    Seleccionar portada
                                </button>
                            </el-upload>

                            <small class="text-muted d-block mt-2">
                                Formatos JPG, PNG o WEBP. Máximo 4 MB.
                            </small>
                        </div>

                        <div v-if="form.cover_url" class="col-md-6">
                            <label>Vista previa</label>

                            <div>
                                <img :src="form.cover_url" class="img-fluid img-thumbnail" alt="Portada de la carta">
                            </div>

                            <button type="button" class="btn btn-danger btn-sm mt-2" @click.prevent="removeCover">
                                <i class="fa fa-trash"></i>
                                Quitar portada
                            </button>
                        </div>
                    </div> -->

                    <h4>Contenido visible</h4>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-2">
                                <el-checkbox v-model="form.show_logo">
                                    Mostrar logo
                                </el-checkbox>
                            </div>

                            <div class="col-md-2">
                                <el-checkbox v-model="form.show_images">
                                    Mostrar imágenes
                                </el-checkbox>
                            </div>

                            <div class="col-md-2">
                                <el-checkbox v-model="form.show_prices">
                                    Mostrar precios
                                </el-checkbox>
                            </div>

                            <div class="col-md-2">
                                <el-checkbox v-model="form.show_descriptions">
                                    Mostrar descripciones
                                </el-checkbox>
                            </div>

                            <div class="col-md-2">
                                <el-checkbox v-model="form.show_contact">
                                    Mostrar contacto
                                </el-checkbox>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="Productos" name="products">
                    <div class="row">
                        <div class="col-md-12">
                            <h4>Productos de la carta</h4>

                            <p class="text-muted">
                                Seleccione cómo se agregarán los productos a esta carta.
                            </p>

                            <el-radio-group v-model="form.selection_mode">
                                <el-radio label="all">
                                    Catálogo completo
                                </el-radio>

                                <el-radio label="manual">
                                    Selección personalizada
                                </el-radio>
                            </el-radio-group>

                            <div v-if="form.selection_mode === 'all'" class="alert alert-info mt-3">
                                <i class="fa fa-info-circle"></i>

                                Se agregarán automáticamente todos los productos activos,
                                agrupados por sus categorías actuales.
                            </div>

                            <div v-if="form.selection_mode === 'manual'" class="row mt-3">
                                <!-- Panel izquierdo: categorías -->
                                <div class="col-12 col-xl-4">
                                    <div class="card mb-0">
                                        <div class="card-header d-flex align-items-center justify-content-between">
                                            <h4 class="m-0">
                                                Categorías
                                            </h4>

                                            <button type="button" class="btn btn-custom btn-sm"
                                                @click.prevent="addCategory">
                                                <i class="fa fa-plus"></i>
                                                Agregar categoría
                                            </button>
                                        </div>

                                        <div class="card-body p-0">
                                            <div v-if="form.categories.length" class="list-group list-group-flush">
                                                <button v-for="(category, categoryIndex) in form.categories"
                                                    :key="category.local_id" type="button"
                                                    class="list-group-item list-group-item-action" :class="{
                                                        'bg-primary text-white':
                                                            selectedCategoryKey ===
                                                            category.local_id
                                                    }" @click.prevent="
                                                        selectCategoryPanel(category)
                                                        ">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div class="text-left">
                                                            <strong>
                                                                {{
                                                                    categoryTitle(
                                                                        category,
                                                                        categoryIndex
                                                                    )
                                                                }}
                                                            </strong>
                                                        </div>

                                                        <div class="d-flex align-items-center">
                                                            <span class="mr-3">
                                                                {{ category.items.length }}
                                                                producto{{ category.items.length === 1 ? '' : 's' }}
                                                            </span>

                                                            <!-- Subir categoría -->
                                                            <span class="mr-2" :class="{
                                                                'text-muted': categoryIndex === 0
                                                            }" title="Subir categoría" @click.prevent.stop="
                                                                moveCategory(categoryIndex, -1)
                                                                ">
                                                                <i class="fa fa-arrow-up"></i>
                                                            </span>

                                                            <!-- Bajar categoría -->
                                                            <span class="mr-3" :class="{
                                                                'text-muted':
                                                                    categoryIndex ===
                                                                    form.categories.length - 1
                                                            }" title="Bajar categoría" @click.prevent.stop="
                                                                moveCategory(categoryIndex, 1)
                                                                ">
                                                                <i class="fa fa-arrow-down"></i>
                                                            </span>

                                                            <!-- Editar categoría -->
                                                            <span class="mr-3" title="Editar categoría"
                                                                @click.prevent.stop="
                                                                    editCategory(category)
                                                                    ">
                                                                <i class="fa fa-pencil-alt"></i>
                                                            </span>

                                                            <!-- Eliminar categoría -->
                                                            <span title="Eliminar categoría" @click.prevent.stop="
                                                                confirmRemoveCategory(categoryIndex)
                                                                ">
                                                                <i class="fa fa-trash"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </button>
                                            </div>

                                            <div v-else class="text-center p-4 text-muted">
                                                <i class="fa fa-folder-open fa-2x mb-2"></i>

                                                <p class="mb-0">
                                                    No existen categorías seleccionadas.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Panel derecho: detalle -->
                                <div class="col-12 col-xl-8 mt-3 mt-xl-0">
                                    <div v-if="selectedCategory" class="card mb-0">
                                        <div class="card-header d-flex align-items-center justify-content-between">
                                            <h4 class="m-0">
                                                Productos —
                                                {{
                                                    categoryTitle(
                                                        selectedCategory,
                                                        selectedCategoryIndex()
                                                    )
                                                }}
                                            </h4>

                                            <button type="button" class="btn btn-info btn-sm" @click.prevent="
                                                editCategory(selectedCategory)
                                                ">
                                                <i class="fa fa-pencil-alt"></i>
                                                Editar categoría
                                            </button>
                                        </div>

                                        <div class="card-body">
                                            <!-- Edición de categoría -->
                                            <div v-if="editingCategory" class="row mb-3">
                                                <div class="col-md-6">
                                                    <label>Nombre personalizado</label>

                                                    <el-input v-model="selectedCategory.custom_name"
                                                        placeholder="Opcional">
                                                    </el-input>
                                                </div>
                                            </div>

                                            <!-- Agregar producto -->
                                            <div>
                                                <label>Agregar producto</label>

                                                <div class="row">
                                                    <div class="col-12 col-xl-9">
                                                        <el-select v-model="selectedCategory.selected_item_id
                                                            " class="w-100" filterable
                                                            placeholder="Seleccione un producto">
                                                            <el-option v-for="item in availableItems(
                                                                selectedCategory
                                                            )" :key="item.id" :label="itemLabel(item)"
                                                                :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </div>

                                                    <div class="col-12 col-xl-3 mt-2 mt-xl-0">
                                                        <button type="button" class="btn btn-success btn-sm btn-block"
                                                            @click.prevent="
                                                                addItem(selectedCategory)
                                                                ">
                                                            <i class="fa fa-plus"></i>
                                                            Agregar producto
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Tabla de productos -->
                                        <div class="table-responsive">
                                            <table class="table table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Producto</th>
                                                        <th>Nombre personalizado</th>
                                                        <th>Precio personalizado</th>
                                                        <th>Disponible</th>
                                                        <th>Destacado</th>
                                                        <th class="text-right">Acciones</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(
menuItem,
    itemIndex
                            ) in selectedCategory.items" :key="menuItem.local_id">
                                                        <td>
                                                            <div>
                                                                <strong>
                                                                    {{ getItemName(menuItem.item_id) }}
                                                                </strong>

                                                                <div v-if="itemHasPresentations(menuItem.item_id)"
                                                                    class="restaurant-menu-presentations">
                                                                    <span
                                                                        v-for="presentation in getItemPresentations(menuItem.item_id)"
                                                                        :key="presentation.id"
                                                                        class="restaurant-menu-presentation">
                                                                        <i class="fa fa-circle"></i>

                                                                        {{ presentation.name }}

                                                                        <strong>
                                                                            S/ {{ Number(presentation.price).toFixed(2)
                                                                            }}
                                                                        </strong>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <el-input v-model="menuItem.custom_name
                                                                " size="small" placeholder="Usar nombre original">
                                                            </el-input>
                                                        </td>

                                                        <td>
                                                            <el-input v-if="!itemHasPresentations(menuItem.item_id)"
                                                                v-model="menuItem.custom_price" size="small" clearable
                                                                placeholder="Usar precio original">
                                                                <template slot="prepend">
                                                                    S/
                                                                </template>
                                                            </el-input>

                                                            <div v-else class="restaurant-menu-presentation-notice">
                                                                <i class="fa fa-info-circle"></i>

                                                                Se utilizarán los precios de las presentaciones.
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <el-switch v-model="menuItem.available">
                                                            </el-switch>
                                                        </td>

                                                        <td>
                                                            <el-switch v-model="menuItem.featured">
                                                            </el-switch>
                                                        </td>

                                                        <td class="text-right">
                                                            <button type="button" class="btn btn-xs btn-secondary"
                                                                :disabled="itemIndex === 0" title="Subir producto"
                                                                @click.prevent="
                                                                    moveProduct(
                                                                        selectedCategory,
                                                                        itemIndex,
                                                                        -1
                                                                    )
                                                                    ">
                                                                <i class="fa fa-arrow-up"></i>
                                                            </button>

                                                            <button type="button" class="btn btn-xs btn-secondary"
                                                                :disabled="itemIndex ===
                                                                    selectedCategory.items.length - 1
                                                                    " title="Bajar producto" @click.prevent="
                                                                        moveProduct(
                                                                            selectedCategory,
                                                                            itemIndex,
                                                                            1
                                                                        )
                                                                        ">
                                                                <i class="fa fa-arrow-down"></i>
                                                            </button>

                                                            <button type="button" class="btn btn-xs btn-danger"
                                                                @click.prevent="
                                                                    removeItem(
                                                                        selectedCategory,
                                                                        itemIndex
                                                                    )
                                                                    ">
                                                                <i class="fa fa-trash"></i>
                                                                Eliminar
                                                            </button>
                                                        </td>
                                                    </tr>

                                                    <tr v-if="
                                                        selectedCategory.items.length === 0
                                                    ">
                                                        <td colspan="6" class="text-center text-muted">
                                                            Esta categoría no tiene productos.
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div v-else class="card mb-0">
                                        <div class="card-body text-center text-muted p-5">
                                            <i class="fa fa-arrow-left fa-2x mb-3"></i>

                                            <p class="mb-0">
                                                Seleccione o agregue una categoría para
                                                administrar sus productos.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="QR" name="qr">
                    <div v-if="form.id" class="restaurant-menu-qr">
                        <div class="row">
                            <div class="col-md-5 text-center">
                                <div class="qr-preview">
                                    <img :src="qrImageUrl" :alt="`QR de ${form.name}`">
                                </div>
                            </div>

                            <div class="col-md-7">
                                <h4>QR de la carta digital</h4>

                                <p class="text-muted">
                                    Al escanear este código se abrirá la ruta pública
                                    de la carta.
                                </p>

                                <label>Dirección incluida en el QR</label>

                                <el-input v-model="form.public_url" readonly>
                                </el-input>

                                <div class="mt-3">
                                    <el-button type="primary" icon="el-icon-printer" @click="printQr">
                                        Imprimir
                                    </el-button>

                                    <a :href="`${qrImageUrl}?download=1`" class="btn btn-outline-info ml-2">
                                        <i class="fa fa-download"></i>
                                        Descargar SVG
                                    </a>

                                    <el-button class="ml-2" icon="el-icon-document-copy" @click="copyPublicUrl">
                                        Copiar enlace
                                    </el-button>
                                </div>

                                <div v-if="!form.published" class="alert alert-warning mt-3 mb-0">

                                    La carta está en borrador. El QR estará listo,
                                    pero la ruta pública no podrá visualizarse hasta
                                    publicar la carta.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="alert alert-info mb-0">
                        Primero debe guardar la carta para generar su código QR.
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <span slot="footer">
            <el-button @click="close">
                Cancelar
            </el-button>

            <el-button type="primary" :loading="loadingSubmit" @click="submit">
                Guardar
            </el-button>
        </span>

        <el-dialog title="Agregar categoría" :visible.sync="showCategoryDialog" width="40%" append-to-body
            :close-on-click-modal="false" @close="closeCategoryDialog">
            <div class="row">
                <div class="col-md-12">
                    <label>
                        Categoría
                        <span class="text-danger">*</span>
                    </label>

                    <el-select v-model="categoryForm.category_id" class="w-100" filterable
                        placeholder="Seleccione una categoría">
                        <el-option v-for="category in availableCategoriesForMenu" :key="category.id"
                            :label="category.name" :value="category.id">
                        </el-option>
                    </el-select>
                </div>

                <div v-if="availableCategoriesForMenu.length === 0" class="col-md-12 mt-3">
                    <div class="alert alert-info mb-0">
                        Todas las categorías disponibles ya fueron agregadas
                        a esta carta.
                    </div>
                </div>
            </div>

            <span slot="footer">
                <el-button @click="closeCategoryDialog">
                    Cancelar
                </el-button>

                <el-button type="primary" :disabled="!categoryForm.category_id ||
                    availableCategoriesForMenu.length === 0
                    " @click="confirmAddCategory">
                    Agregar
                </el-button>
            </span>
        </el-dialog>

        <el-dialog title="Editar categoría" :visible.sync="showEditCategoryDialog" width="40%" append-to-body
            :close-on-click-modal="false" @close="closeEditCategoryDialog">
            <div class="row">
                <div class="col-md-12">
                    <label>Categoría original</label>

                    <el-input v-model="editCategoryForm.original_name" disabled>
                    </el-input>
                </div>

                <div class="col-md-12 mt-3">
                    <label>Nombre personalizado</label>

                    <el-input v-model="editCategoryForm.custom_name" clearable placeholder="Usar nombre original">
                    </el-input>

                    <small class="text-muted">
                        Si lo deja vacío, se utilizará el nombre original
                        de la categoría.
                    </small>
                </div>
            </div>

            <span slot="footer">
                <el-button @click="closeEditCategoryDialog">
                    Cancelar
                </el-button>

                <el-button type="primary" @click="confirmEditCategory">
                    Guardar cambios
                </el-button>
            </span>
        </el-dialog>

    </el-dialog>
</template>

<script>
export default {
    props: ['showDialog', 'recordId'],

    data() {
        return {
            resource: 'restaurant/v2/menus',
            activeTab: 'general',
            selectedCategoryKey: null,
            loading: false,
            loadingSubmit: false,
            establishments: [],
            categories: [],
            items: [],
            templates: [],
            form: {},
            showCategoryDialog: false,
            categoryForm: {
                category_id: null,
                custom_name: null,
            },
            showEditCategoryDialog: false,
            editCategoryForm: {
                local_id: null,
                category_id: null,
                original_name: null,
                custom_name: null,
            },
        }
    },

    computed: {
        title() {
            return this.form.id
                ? 'Editar carta digital'
                : 'Nueva carta digital'
        },
        selectedCategory() {
            if (
                !this.form.categories ||
                !this.selectedCategoryKey
            ) {
                return null
            }

            return this.form.categories.find(
                category =>
                    category.local_id ===
                    this.selectedCategoryKey
            ) || null
        },
        availableCategoriesForMenu() {
            if (!this.form.categories) {
                return this.categories
            }

            const selectedIds = this.form.categories
                .filter(category => category.category_id)
                .map(category => Number(category.category_id))

            return this.categories.filter(
                category =>
                    !selectedIds.includes(Number(category.id))
            )
        },
        qrImageUrl() {
            if (!this.form.id) {
                return null
            }

            return `/${this.resource}/${this.form.id}/qr`
        },

        qrPrintUrl() {
            if (!this.form.id) {
                return null
            }

            return `/${this.resource}/${this.form.id}/qr-print`
        },
    },

    watch: {
        showDialog(value) {
            if (value) {
                this.open()
            }
        },
    },

    methods: {
        initForm() {
            this.form = {
                id: null,
                establishment_id: null,
                name: null,
                slug: null,
                public_url: null,
                description: null,
                template: 'menu1',
                selection_mode: 'all',
                cover: null,
                cover_url: null,
                primary_color: '#8f1d14',
                secondary_color: '#f4b942',
                telephone: null,
                whatsapp: null,
                address: null,
                email: null,
                show_logo: true,
                show_images: true,
                show_prices: true,
                show_descriptions: true,
                show_contact: true,
                published: false,
                is_default: false,
                categories: [],
            }
        },

        open() {
            this.activeTab = 'general'
            this.selectedCategoryKey = null
            this.loading = true
            this.initForm()

            this.$http
                .get(`/${this.resource}/tables`)
                .then(response => {
                    this.establishments = response.data.establishments
                    this.categories = response.data.categories
                    this.items = response.data.items
                    this.templates = response.data.templates

                    if (!this.recordId) {
                        if (this.establishments.length) {
                            this.form.establishment_id =
                                this.establishments[0].id
                        }

                        return null
                    }

                    return this.$http.get(
                        `/${this.resource}/record/${this.recordId}`
                    )
                })
                .then(response => {
                    if (response) {
                        this.form = response.data.data

                        if (!this.form.selection_mode) {
                            this.form.selection_mode = 'manual'
                        }

                        this.form.categories =
                            this.form.categories.map(category => {
                                category.local_id = this.generateId()
                                category.selected_item_id = null
                                category.items =
                                    category.items.map(item => {
                                        item.local_id = this.generateId()

                                        if (item.custom_price !== null) {
                                            item.custom_price =
                                                Number(item.custom_price)
                                        }

                                        return item
                                    })

                                return category
                            })

                        this.selectedCategoryKey =
                            this.form.categories.length
                                ? this.form.categories[0].local_id
                                : null

                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        addCategory() {
            if (this.availableCategoriesForMenu.length === 0) {
                this.$message.info(
                    'Todas las categorías ya fueron agregadas'
                )

                return
            }

            this.categoryForm = {
                category_id: null,
                custom_name: null,
            }

            this.showCategoryDialog = true
        },

        confirmAddCategory() {
            if (!this.categoryForm.category_id) {
                this.$message.warning(
                    'Seleccione una categoría'
                )

                return
            }

            const alreadyExists = this.form.categories.some(
                category =>
                    Number(category.category_id) ===
                    Number(this.categoryForm.category_id)
            )

            if (alreadyExists) {
                this.$message.warning(
                    'La categoría ya fue agregada a esta carta'
                )

                return
            }

            const category = {
                local_id: this.generateId(),
                id: null,
                category_id: this.categoryForm.category_id,
                custom_name:
                    this.categoryForm.custom_name || null,
                description: null,
                visible: true,
                sort_order: this.form.categories.length + 1,
                selected_item_id: null,
                items: [],
            }

            this.form.categories.push(category)

            /*
             * Seleccionamos automáticamente la categoría
             * para habilitar el panel derecho.
             */
            this.selectedCategoryKey = category.local_id

            this.closeCategoryDialog()
        },

        closeCategoryDialog() {
            this.showCategoryDialog = false

            this.categoryForm = {
                category_id: null,
                custom_name: null,
            }
        },

        selectCategoryPanel(category) {
            this.selectedCategoryKey = category.local_id
        },

        editCategory(category) {
            if (!category) {
                return
            }

            this.selectedCategoryKey = category.local_id

            const originalCategory = this.categories.find(
                row =>
                    Number(row.id) ===
                    Number(category.category_id)
            )

            this.editCategoryForm = {
                local_id: category.local_id,
                category_id: category.category_id,
                original_name: originalCategory
                    ? originalCategory.name
                    : 'Sin categoría',
                custom_name: category.custom_name || null,
            }

            this.showEditCategoryDialog = true
        },

        selectedCategoryIndex() {
            if (!this.selectedCategory) {
                return -1
            }

            return this.form.categories.findIndex(
                category =>
                    category.local_id ===
                    this.selectedCategory.local_id
            )
        },

        categoryTitle(category, index) {
            if (category.custom_name) {
                return category.custom_name
            }

            if (category.category_id) {
                const originalCategory = this.categories.find(
                    row =>
                        Number(row.id) ===
                        Number(category.category_id)
                )

                if (originalCategory) {
                    return originalCategory.name
                }
            }

            return `Categoría ${index + 1}`
        },

        confirmRemoveCategory(index) {
            const category = this.form.categories[index]

            const productCount = category.items
                ? category.items.length
                : 0

            const message = productCount > 0
                ? `La categoría contiene ${productCount} productos. ¿Desea eliminarla?`
                : '¿Desea eliminar esta categoría?'

            this.$confirm(
                message,
                'Eliminar categoría',
                {
                    confirmButtonText: 'Eliminar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning',
                }
            ).then(() => {
                this.removeCategory(index)
            }).catch(() => { })
        },

        removeCategory(index) {
            const removedCategory =
                this.form.categories[index]

            this.form.categories.splice(index, 1)

            if (
                removedCategory &&
                this.selectedCategoryKey ===
                removedCategory.local_id
            ) {
                const nextCategory =
                    this.form.categories[index]
                    || this.form.categories[index - 1]
                    || this.form.categories[0]

                this.selectedCategoryKey = nextCategory
                    ? nextCategory.local_id
                    : null
            }

        },

        selectCategory(category) {
            category.selected_item_id = null
        },

        availableItems(category) {
            const selectedIds = category.items.map(row =>
                Number(row.item_id)
            )

            return this.items.filter(item => {
                const sameCategory =
                    !category.category_id ||
                    Number(item.category_id) ===
                    Number(category.category_id)

                return (
                    sameCategory &&
                    !selectedIds.includes(Number(item.id))
                )
            })
        },

        addItem(category) {
            if (!category.selected_item_id) {
                this.$message.warning('Seleccione un producto')
                return
            }

            const original = this.items.find(
                row =>
                    Number(row.id) ===
                    Number(category.selected_item_id)
            )

            if (!original) {
                return
            }

            category.items.push({
                local_id: this.generateId(),
                item_id: original.id,
                custom_name: null,
                custom_description: null,
                custom_price: null,
                sort_order: category.items.length + 1,
                featured: false,
                visible: true,
                available: true,
            })

            category.selected_item_id = null
        },

        removeItem(category, index) {
            category.items.splice(index, 1)
        },

        getItem(itemId) {
            return this.items.find(
                item => Number(item.id) === Number(itemId)
            )
        },

        getItemPresentations(itemId) {
            const item = this.getItem(itemId)

            if (
                !item ||
                !Array.isArray(item.presentations)
            ) {
                return []
            }

            return item.presentations
        },

        itemHasPresentations(itemId) {
            return this.getItemPresentations(itemId).length > 0
        },

        getItemName(itemId) {
            const item = this.getItem(itemId)

            return item
                ? item.description
                : `Producto ${itemId}`
        },

        itemLabel(item) {
            if (item.internal_id) {
                return `${item.internal_id} - ${item.description}`
            }

            return item.description
        },

        submit() {
            if (!this.form.name) {
                this.$message.warning(
                    'Ingrese el nombre de la carta'
                )
                return
            }

            if (!this.form.establishment_id) {
                this.$message.warning(
                    'Seleccione un establecimiento'
                )
                return
            }

            this.normalizeColor(
                'primary_color',
                '#8F1D14'
            )

            this.normalizeColor(
                'secondary_color',
                '#F4B942'
            )

            this.normalizeCustomPrices()

            this.updateCategoryOrder()

            this.form.categories.forEach(category => {
                this.updateProductOrder(category)
            })

            this.loadingSubmit = true

            this.$http
                .post(`/${this.resource}`, this.form)
                .then(response => {
                    this.$message.success(response.data.message)
                    this.$emit('saved')
                    this.close()
                })
                .catch(error => {
                    let message = 'No se pudo guardar la carta'

                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        message = error.response.data.message
                    }

                    this.$message.error(message)

                    /*
                     * Si el error está relacionado con productos,
                     * abrimos automáticamente ese tab.
                     */
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.errors
                    ) {
                        const errors = error.response.data.errors

                        if (
                            errors.categories ||
                            errors.published
                        ) {
                            this.activeTab = 'products'
                        }
                    }
                })
                .finally(() => {
                    this.loadingSubmit = false
                })
        },

        close() {
            this.activeTab = 'general'
            this.selectedCategoryKey = null

            this.closeCategoryDialog()
            this.closeEditCategoryDialog()

            this.$emit('update:showDialog', false)
        },

        generateId() {
            return `${Date.now()}-${Math.random()}`
        },

        changeColor(field, color) {
            const hexadecimal = this.toHexColor(color)

            if (hexadecimal) {
                this.form[field] = hexadecimal
            }
        },

        toHexColor(color) {
            if (!color) {
                return null
            }

            const value = String(color).trim()

            if (/^#[0-9A-F]{6}$/i.test(value)) {
                return value.toUpperCase()
            }

            const rgb = value.match(
                /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/i
            )

            if (!rgb) {
                return null
            }

            const components = [
                Number(rgb[1]),
                Number(rgb[2]),
                Number(rgb[3]),
            ]

            if (components.some(component => component > 255)) {
                return null
            }

            return `#${components
                .map(component => component.toString(16).padStart(2, '0'))
                .join('')
                .toUpperCase()}`
        },

        normalizeColor(field, fallback) {
            const hexadecimal = this.toHexColor(this.form[field])

            if (!hexadecimal) {
                this.$message.warning(
                    'Ingrese un color hexadecimal válido'
                )

                this.form[field] = fallback
                return false
            }

            this.form[field] = hexadecimal

            return true
        },

        openPreview() {
            if (!this.form.id) {
                this.$message.warning(
                    'Primero debe guardar la carta'
                )

                return
            }

            this.normalizeColor(
                'primary_color',
                '#8F1D14'
            )

            this.normalizeColor(
                'secondary_color',
                '#F4B942'
            )

            const template = this.form.template || 'menu1'

            const parameters = new URLSearchParams({
                primary_color: this.form.primary_color,
                secondary_color: this.form.secondary_color,
            })

            window.open(
                `/restaurant/menu-preview/${this.form.id}/${template}?${parameters.toString()}`,
                '_blank'
            )
        },
        normalizeCustomPrices() {
            this.form.categories.forEach(category => {
                category.items.forEach(item => {
                    if (this.itemHasPresentations(item.item_id)) {
                        item.custom_price = null
                        return
                    }

                    if (
                        item.custom_price === '' ||
                        item.custom_price === null ||
                        typeof item.custom_price === 'undefined'
                    ) {
                        item.custom_price = null
                        return
                    }

                    const price = Number(item.custom_price)

                    item.custom_price = isNaN(price)
                        ? null
                        : price
                })
            })
        },

        confirmEditCategory() {
            const category = this.form.categories.find(
                row =>
                    row.local_id ===
                    this.editCategoryForm.local_id
            )

            if (!category) {
                this.$message.error(
                    'No se encontró la categoría'
                )

                this.closeEditCategoryDialog()
                return
            }

            const customName =
                this.editCategoryForm.custom_name

            category.custom_name =
                customName && customName.trim()
                    ? customName.trim()
                    : null

            this.$message.success(
                'Categoría actualizada'
            )

            this.closeEditCategoryDialog()
        },

        closeEditCategoryDialog() {
            this.showEditCategoryDialog = false

            this.editCategoryForm = {
                local_id: null,
                category_id: null,
                original_name: null,
                custom_name: null,
            }
        },

        moveCategory(index, direction) {
            const newIndex = index + direction

            if (
                newIndex < 0 ||
                newIndex >= this.form.categories.length
            ) {
                return
            }

            const movedCategory =
                this.form.categories.splice(index, 1)[0]

            this.form.categories.splice(
                newIndex,
                0,
                movedCategory
            )

            this.updateCategoryOrder()
        },

        moveProduct(category, index, direction) {
            if (!category || !category.items) {
                return
            }

            const newIndex = index + direction

            if (
                newIndex < 0 ||
                newIndex >= category.items.length
            ) {
                return
            }

            const movedItem =
                category.items.splice(index, 1)[0]

            category.items.splice(
                newIndex,
                0,
                movedItem
            )

            this.updateProductOrder(category)
        },

        updateCategoryOrder() {
            this.form.categories.forEach(
                (category, index) => {
                    category.sort_order = index + 1
                }
            )
        },

        updateProductOrder(category) {
            if (!category || !category.items) {
                return
            }

            category.items.forEach(
                (item, index) => {
                    item.sort_order = index + 1
                }
            )
        },

        uploadCover(options) {
            const formData = new FormData()

            formData.append('file', options.file)

            this.$http
                .post(
                    `/${this.resource}/upload-cover`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                )
                .then(response => {
                    this.form.cover =
                        response.data.filename

                    this.form.cover_url =
                        response.data.url

                    this.$message.success(
                        response.data.message
                    )
                })
                .catch(error => {
                    const message =
                        error.response &&
                            error.response.data &&
                            error.response.data.message
                            ? error.response.data.message
                            : 'No se pudo cargar la portada'

                    this.$message.error(message)
                })
        },

        removeCover() {
            this.form.cover = null
            this.form.cover_url = null
        },

        printQr() {
            if (!this.qrPrintUrl) {
                this.$message.warning(
                    'Primero debe guardar la carta'
                )

                return
            }

            window.open(
                this.qrPrintUrl,
                '_blank'
            )
        },

        copyPublicUrl() {
            if (!this.form.public_url) {
                return
            }

            if (
                navigator.clipboard &&
                navigator.clipboard.writeText
            ) {
                navigator.clipboard
                    .writeText(this.form.public_url)
                    .then(() => {
                        this.$message.success(
                            'Enlace copiado correctamente'
                        )
                    })

                return
            }

            const textarea = document.createElement('textarea')

            textarea.value = this.form.public_url
            textarea.style.position = 'fixed'
            textarea.style.opacity = '0'

            document.body.appendChild(textarea)

            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)

            this.$message.success(
                'Enlace copiado correctamente'
            )
        },
    },
}
</script>

<style>
.instant-color-picker .el-color-dropdown__btn {
    display: none !important;
}

.restaurant-menu-qr {
    padding: 25px 10px;
}

.restaurant-menu-qr .qr-preview {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 340px;
    padding: 20px;
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 8px;
}

.restaurant-menu-qr .qr-preview img {
    display: block;
    width: 100%;
    height: auto;
}

.restaurant-menu-presentations {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    margin-top: 7px;
}

.restaurant-menu-presentation {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #606266;
    font-size: 12px;
}

.restaurant-menu-presentation i {
    color: #00b19d;
    font-size: 6px;
}

.restaurant-menu-presentation strong {
    color: #303133;
    white-space: nowrap;
}

.restaurant-menu-presentation-notice {
    max-width: 210px;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
}

.restaurant-menu-presentation-notice i {
    margin-right: 4px;
    color: #e6a23c;
}
</style>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/menus/form.vue